import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Form, Button, Col } from "react-bootstrap";
import { InputField } from "../../shared";

function FormikForm(props) {
  const [advancedToggle, setAdvancedToggle] = useState(false);
  const toggleAdvanced = () => setAdvancedToggle(!advancedToggle);

  useEffect(() => {
    let advanced = props.formConfig.filter(e => e.config.advanced === true);
    if (advanced.length > 0) {
      for (var i = 0; i < advanced.length; i++) {
        if (props.initialFormValues[advanced[i].name]) {
          if (props.initialFormValues[advanced[i].name].constructor !== Array) {
            setAdvancedToggle(true)
            break;
          } else {
            if (props.initialFormValues[advanced[i].name].length > 0) {
              setAdvancedToggle(true);
              break;
            }
          }
        }
      }
    }
  }, [])

  const onReset = (resetForm) => {
    var newValues = {};

    Object.keys(props.initialFormValues).map((key, index) => {
      newValues[key] = "";
      if (key.startsWith("multi")) {
        newValues[key] = [];
      }
    });
    resetForm({ values: newValues });
  };

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={props.schema}
      onSubmit={(data, { setSubmitting, resetForm, setErrors }) => {
        setSubmitting(true);
        props.onSubmit(data, { setSubmitting, resetForm, setErrors });
      }}
      initialValues={props.initialFormValues}
      innerRef={props.formRef}
    >
      {({
        isSubmitting,
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        setErrors,
        resetForm,
        setFieldValue,
      }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Form.Row>
            {props.formConfig.map((input, i) => (
              (input.config.advanced !== true && input.config.hide !== true) &&
              <InputField
                initialFormValues={props.initialFormValues[input.name]}
                setFieldValue={setFieldValue}
                key={i}
                name={input.name}
                config={input.config}
                values={values}
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                errors={errors}
                touched={touched}
                validationSchema={props.schema}
              />
            ))}
          </Form.Row>
          {advancedToggle === true && props.formConfig.filter(e => e.config.advanced === true && e.config.hide !== true).length > 0 ?
            <Form.Row>
              <Col>
                <div className="panel-group accordion " id="advanced-filters-accordion" role="tablist" aria-multiselectable="true">
                  <div className="panel panel-default advanced-filters-card" style={{ border: "none" }}>
                    <div id="collapseReportDescription" className={`panel-collapse collapse ${advancedToggle === true && "show"}`} role="tabpanel" aria-labelledby="advanced-filters-heading">
                      <div className="">
                        <Form.Row>
                          {props.formConfig.map((input, i) => (
                            (input.config.advanced === true && input.config.hide !== true) &&
                            <InputField
                              initialFormValues={props.initialFormValues[input.name]}
                              setFieldValue={setFieldValue}
                              key={i}
                              name={input.name}
                              config={input.config}
                              values={values}
                              handleChange={handleChange}
                              handleSubmit={handleSubmit}
                              errors={errors}
                              touched={touched}
                              validationSchema={props.schema}
                            />
                          ))}
                        </Form.Row>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Form.Row>
            : null}
          <Form.Row>
            <Form.Group as={Col} md="1">
              {isSubmitting === true ? (
                <div
                  className="cancel-button btn btn-block-xs"
                  style={{ minWidth: "74px", maxHeight: "39px", width: "100%" }}
                  onClick={() => {
                    props.cancelCall();
                  }}
                  title="Cancel Search"
                >
                  <span className="ca-gov-icon-do-not-sign formearch">
                    <span className="sr-only">Cancel</span>
                  </span>
                </div>
              ) :
                <Button
                  id="report-submit"
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-block-xs"
                  style={{ width: "100%" }}
                >
                  Search
                </Button>
              }
            </Form.Group>
            <Form.Group as={Col} md="1">
              <Button
                onClick={() => onReset(resetForm)}
                type="reset"
                className="btn-block-xs"
                disabled={isSubmitting}
                style={{ width: "100%" }}
              >
                Reset
              </Button>
            </Form.Group>
            {props.formConfig.filter(e => e.config.advanced === true && e.config.hide !== true).length > 0 &&
              <Form.Group as={Col} md="1">
                <Button
                  variant="secondary"
                  onClick={() => toggleAdvanced()}
                  type="button"
                  className="btn-block-xs"
                  disabled={isSubmitting}
                >
                  Advanced
                <i className={`ca-gov-icon-filter-solid ml-2`} />
                </Button>
              </Form.Group>
            }
          </Form.Row>
          {/* {REACT_APP_HOST_ENV == "local" && (
            <pre>{JSON.stringify(values, null, 2)}</pre>
          )} */}
        </Form>
      )}
    </Formik>
  );
}

export default FormikForm;
